<template>
  <scroll-view>
    <template slot-scope="visibility">
      <div class="museum fixed-nav">
        <MainHeader :tiles="false" :dark="true" :fixedMenu="true">
          <svg>
            <use v-if="selectedTranslation === 'en'" xlink:href="#logoMkSvgEng"></use>
            <use v-else xlink:href="#logoMkSvg"></use>
          </svg>
        </MainHeader>
        <div class="sections">
          <section class="section-main text-slider">
            <HeroSlider
              :items="museumData.hero.items"
              :header="museumData.hero.header"
              :description="museumData.hero.description"
              key="hero"/>
          </section>
          <VirtualMuseumSection
            key="VirtualMuseumSection"
            :visible="visibility.VirtualMuseumSection" />
          <OverflowSection
            class="section-main"
            :description="museumData.sectionHeart.description"
            :header="museumData.sectionHeart.header"
            :image="museumData.sectionHeart.image"
            key="OverflowSection"
            :visible="visibility.OverflowSection"
            :mobile="isMobile"/>
          <GallerySectionMobile
            v-if="isMobile"
            class="section-main"
            :description="museumData.gallery.description"
            :header="museumData.gallery.header"
            :items="museumData.gallery.items"
            key="GallerySectionMobile"/>
          <GallerySection
            v-else
            class="section-main"
            :description="museumData.gallery.description"
            :header="museumData.gallery.header"
            :items="museumData.gallery.items"
            key="GallerySection"
            />
          <EdificeSectionMobile
            v-if="isMobile"
            class="section-main"
            :edifice="museumData.edifice"
            key="EdificeSectionMobile"/>
          <EdificeSection
            v-else
            class="section-main"
            :edifice="museumData.edifice"
            key="EdificeSection"/>
          <TilesSection
            class="section-main"
            :tiles="museumData.tiles"
            key="TilesSection"/>
          <OverflowRightSection
            class="section-main"
            :description="museumData.why.description"
            :header="museumData.why.header"
            :image="museumData.why.image"
            key="OverflowRightSection"
            :visible="visibility.OverflowRightSection"/>
          <RoadMapSection
            class="section-main"
            :description="museumData.road.description"
            :caption="museumData.road.caption"
            :image="museumData.road.image"
            :items="museumData.road.items"
            key="RoadMapSection"/>
          <QuoteSection
            class="section-main"
            :quote="museumData.quote"
            key="QuoteSection"
            :visible="visibility.QuoteSection" />
          <MainFooter
            key="footer"
            :content="footerData"
          />
        </div>
      </div>
    </template>
  </scroll-view>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import MainHeader from '@/components/MainHeader.vue'
import MainFooter from '@/components/MainFooter.vue'
import HeroSlider from '@/components/HeroSlider.vue'
import EdificeSectionMobile from '@/components/EdificeSectionMobile.vue'
import OverflowSection from '@/components/OverflowSection.vue'
import TilesSection from '@/components/TilesSection.vue'
import GallerySection from '@/components/GallerySection.vue'
import GallerySectionMobile from '@/components/GallerySectionMobile.vue'
import EdificeSection from '@/components/EdificeSection.vue'
import OverflowRightSection from '@/components/OverflowRightSection.vue'
import RoadMapSection from '@/components/RoadMapSection.vue'
import QuoteSection from '@/components/QuoteSection.vue'
import VirtualMuseumSection from '@/components/VirtualMuseumSection.vue'

export default {
  name: 'museum',
  components: {
    MainHeader,
    HeroSlider,
    OverflowSection,
    TilesSection,
    GallerySection,
    GallerySectionMobile,
    EdificeSection,
    EdificeSectionMobile,
    MainFooter,
    OverflowRightSection,
    RoadMapSection,
    QuoteSection,
    VirtualMuseumSection
  },
  methods: {
    ...mapActions([
      'resetActiveFilters'
    ])
  },
  computed: {
    ...mapGetters([
      'museumData',
      'footerData',
      'breakpoint',
      'selectedTranslation'
    ]),
    isMobile () {
      return this.breakpoint === 'mobile' || this.breakpoint === 'tablet'
    }
  },
  mounted () {
    this.resetActiveFilters()
  }
}
</script>

<style scoped lang="scss">
  .museum .main-header:not(.is-fixed) {
    button {
      filter: drop-shadow( 1px 1px 1px rgba(0,0,0,0.4) );
    }
  }
  .museum {
    /deep/ .mobile-bottom-menu {
      background: linear-gradient(rgba($bg-dark, 0), rgba($bg-dark, 0.75));
    }
  }
  @include mobile {
    .text-slider {
      /deep/ .controllers {
        top: -72px;
      }
    }
  }

.museum /deep/ .see-icon {
  display: block;
  margin: $gap-md 0;
  width: 100%;

  span {
    display: inline-block;
    padding-right: ($icon-see-size + $gap-sm);
    position: relative;
    width: auto;

    &:after {
      @include after(auto, $icon-see-size, ceil($icon-see-size / -2) 0 0 0, 50%, $icon-see-size, 10);
      background: transparent bg-icon('icon-eye', $color-text) no-repeat 50% 50%;
      background-size: cover;
      right: ceil($gap-sm / 2);

      .dark & {
        background-image: bg-icon('icon-eye', $contrast-text);
        background-size: cover;
      }
    } // END span:after

  }

}
</style>
